import { HomePageResponse, onBoardUserAttr } from "@/components/PageHome/api/interface";
import { fetchArticles } from "@/components/ArticleComponent/api";
import { API_BASE_URL } from "@/libs/constants/apis";
import { fetchUtil } from "@/libs/fetch";

export const fetchHomePageAPI: (
  pageUrl?: string,
  apolloLogger?: any,
  correlationId?: any
) => Promise<HomePageResponse> = async (pageUrl, apolloLogger, correlationId) => {
  console.log("====================================");
  console.log(API_BASE_URL);
  console.log("====================================");

  return await fetchUtil({
    url: `${API_BASE_URL}/api/home-page?populate=deep,5`,
    method: "GET",
    body: {},
    useToken: false,
    pageUrl,
    apolloLogger,
    correlationId,
  });
};

export const onBoardUserAPI: (
  payload: onBoardUserAttr,
  pageUrl?: string,
  apolloLogger?: any,
  correlationId?: any
) => Promise<any> = async (payload, pageUrl, apolloLogger, correlationId) => {
  return await fetchUtil({
    url: `${API_BASE_URL}/api/custom-home-route?populate=deep,5`,
    method: "POST",
    body: payload,
    useToken: false,
    pageUrl,
    apolloLogger,
    correlationId,
  });
};

export const fetchArticlesAPI: (slug: string) => Promise<any> = async (slug) => {
  return fetchArticles({ categorySlug: slug });
};
